import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withFormik } from 'formik';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { bindPromiseCreators, promisifyRoutine } from 'redux-saga-routines';

import { LoginForm } from './loginForm.component';
import { LoginSchema, defaultValues } from './loginForm.constants';
import { loginRoutine } from '../../../modules/auth/auth.redux';

export const loginRoutinePromiseCreator = promisifyRoutine(loginRoutine);

const mapStateToProps = createStructuredSelector({});

export const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({}, dispatch),
  ...bindPromiseCreators({ loginRoutinePromiseCreator }, dispatch),
});

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withFormik({
    mapPropsToValues: () => defaultValues,
    handleSubmit: async (data, { props, ...formik }) => {
      try {
        formik.setSubmitting(true);

        await props.loginRoutinePromiseCreator(data);
      } catch ({ errors }) {
        formik.setErrors(errors);
      } finally {
        formik.setSubmitting(false);
      }
    },
    validationSchema: () => LoginSchema,
    validateOnChange: false,
  })
)(LoginForm);
